module.exports = __webpack_public_path__ + "img/notification.7e4fa015.svg";